import "./communityActionModal.scss";
import { useContext, useState, useEffect } from "react";
// redux
import { useDispatch } from "react-redux";
// context
import { UserContext } from "@src/App";
// hooks
import { useBroadcastChannel } from "@src/utils/hooks/useBroadcastChannel";
import { useInterWindow } from "@src/utils/hooks/useInterWindow";
// api
import { blockCommunity, deleteReview } from "@src/api/community/community";
// components
import BottomFixedModal from "../common/bottomFixedModal/BottomFixedModal";
import Blank from "../common/blank/Blank";
import Modal from "../common/modal/Modal";

// 신고/차단 모달 인터페이스
interface Params {
  isShow?: boolean;
  category: 1 | 2 | 3;
  communityUuid: string;
  customerUuid: string;
  clearData: (result?: boolean) => void;
}
/**
 *
 * 커뮤니티 신고/차단 모달
 * @param isShow 모달 표시 여부
 * @param category  1 : 리뷰 2 : 댓글 3 : ?(확인 필요)
 * @param communityUuid 게시글 uuid
 * @param customerUuid 사용자 uuid
 * @param clearData 데이터 초기화 함수 result 새로고침 필요 여부
 */
const CommunityActionModal = ({
  isShow = true,
  category,
  communityUuid,
  customerUuid,
  clearData,
}: Params) => {
  // user
  const user = useContext(UserContext);

  // 신고/차단 선택값 1: 게시글 신고, 2: 사용자 신고, 3: 이 사용자 차단, 4: 이 게시글 차단
  const [selected, setSelected] = useState("");

  // 신고 모달, 삭제 모달 상태
  const [isShowDeleteModal, setIsShowDeleteModal] = useState(false);

  // 신고하기 상세 모달 열기 설정
  const { openWindow: openReportDetail } = useInterWindow({
    id: "communityModal",
    receiverId: "report",
  });

  // 모달 열림 상태에 따라 초기화
  useEffect(() => {
    if (!isShow) {
      setSelected("");
    }
  }, [isShow]);

  // 결과
  const actionResult = (result?: boolean) => {
    clearData(result);
  };

  // 신고 모달 브로드캐스트
  const { broadcastMessage: sendReportMessage } = useBroadcastChannel(
    "report",
    (e: MessageEvent) => {
      if (e?.data?.type === "clearData" && e?.data?.id === "report") {
        actionResult(); // 별도 리스트 갱신은 필요하지 않으므로 result 값 없음
      }
    },
  );

  // 신고 모달 열기
  const openReportModal = () => {
    openReportDetail(
      {
        communityUuid: communityUuid,
        customerUuid: customerUuid,
        category: category,
      },
      {
        url: `/community/report`,
        hidetop: true,
        hidesafearea: false,
      },
    );
  };

  // 차단하기
  const block = () => {
    if (user.me) {
      blockCommunity({
        myUuid: user.me.uuid,
        targetUuid: customerUuid,
      })
        .then((_) => {
          alert("차단 되었습니다.");
          actionResult(true);
        })
        .catch((e) => {
          alert(
            `${e.response?.data?.msg ? e.response.data.msg : "예기치 못한 오류가 발생했습니다. 잠시 후 다시 시도해주세요."}`,
          );
        });
    }
  };

  // 사용자 정보가 없으면 진행 안함
  if (!user.me) return null;
  return (
    <>
      <div className="community-modal-wrap">
        <BottomFixedModal
          title={""}
          // titleHidden={true}
          isShow={isShow}
          isTransition={true}
          hideModal={() => actionResult()}
          overlayBgColor={isShowDeleteModal ? "transparent" : "rgba(0, 0, 0, .5)"}
          className=""
        >
          <div>
            <ul className="bottom-modal-content-list">
              {customerUuid === user.me.uuid ? (
                <>
                  {category === 2 ? (
                    <>
                      <li
                        onClick={() => {
                          window.location.href = `h2mwbell://community/review/edit?reviewUuid=${communityUuid}`;
                        }}
                      >
                        수정
                      </li>
                      <li onClick={() => setIsShowDeleteModal(true)}>삭제</li>
                    </>
                  ) : (
                    <>{/* 댓글인 경우 */}</>
                  )}
                </>
              ) : (
                <>
                  <li
                    className={selected === "1" ? "on" : ""}
                    onClick={() => {
                      openReportModal();
                      setSelected("1");
                    }}
                  >
                    게시글 신고<i className="icon icon-checkmark-brown500"></i>
                  </li>
                  <li
                    className={selected === "2" ? "on" : ""}
                    onClick={() => {
                      openReportModal();
                      setSelected("2");
                    }}
                  >
                    사용자 신고<i className="icon icon-checkmark-brown500"></i>
                  </li>
                  <li
                    className={selected === "3" ? "on" : ""}
                    onClick={() => {
                      block();
                      setSelected("3");
                    }}
                  >
                    이 사용자 차단<i className="icon icon-checkmark-brown500"></i>
                  </li>
                  <li
                    className={selected === "4" ? "on" : ""}
                    onClick={() => {
                      block();
                      setSelected("4");
                    }}
                  >
                    이 게시글 차단<i className="icon icon-checkmark-brown500"></i>
                  </li>
                </>
              )}
            </ul>
          </div>
        </BottomFixedModal>
        {/* 삭제 확인 모달 */}
        {isShowDeleteModal && (
          <Modal
            isShow={true}
            overlay={true}
            overlayValue={0.5}
            overlayStyle={{ zIndex: 99998 }}
            zIndex={99999}
            text={`${category === 2 ? "리뷰를" : "댓글을"} 삭제하시겠습니까?
          삭제 후에는 복구가 불가합니다.`}
            buttons={[
              {
                name: "아니요",
                className: "btn-gray50",
                action: () => {
                  setIsShowDeleteModal(false);
                },
              },
              {
                name: "삭제",
                className: "btn-red500",
                action: () => {
                  deleteReview(communityUuid)
                    .then((_) => {
                      setIsShowDeleteModal(false);
                      actionResult(true);
                    })
                    .catch((e) => {
                      alert(`에러가 발생했습니다. 잠시 후 다시 시도해주세요.`);
                    });
                },
              },
            ]}
          />
        )}
      </div>
    </>
  );
};

export default CommunityActionModal;
